import React,{ useRef } from 'react'
import { Modal, ModalHeader, ModalBody, Label } from 'reactstrap'
import { FilePond, registerPlugin } from 'react-filepond'
import FilePondPluginImagePreview from "filepond-plugin-image-preview"
import FilePondPluginMediaPreview from "filepond-plugin-media-preview"

import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'
import 'filepond-plugin-media-preview/dist/filepond-plugin-media-preview.min.css';

import { getFileSizeValidity } from 'utils/fileSizeValidator'
import Lang from 'Lang/General'

registerPlugin( FilePondPluginImagePreview, FilePondPluginMediaPreview )

const UploadModal = props => {
  const mainFilePondRef = useRef( null )

  return (
    <Modal size='sm' isOpen={ props.isUploadModalOpen } >
      <ModalHeader toggle={ () => props.setIsUploadModalOpen( false ) } >
        { Lang[ 'UPLOAD' ][ props.selectedLanguage ] }
      </ModalHeader>
      <ModalBody>
        <Label style={{ fontSize: '11px', color: '#212529' }}>{ Lang[ 'MAXIMUM_FILE_SIZE_10_MB' ][ props.selectedLanguage ]}</Label>
        <FilePond
          ref={ mainFilePondRef }
          onupdatefiles={ fileItems => {
            if ( getFileSizeValidity( fileItems, props.selectedLanguage ) ) {
              let tmpFiles = []

              fileItems.map( file => {
                const reader = new FileReader()
                reader.onload = e => {
                  tmpFiles.push({
                    file: {
                      raw: e.target.result,
                      filename: file.filenameWithoutExtension
                    }
                  })
                  if( tmpFiles.length === fileItems.length ){
                    if (!props.isInternalDialogue){
                      props.onChangeDialogsHOC( 
                        'dialogueMessage',
                        {
                          ...props.dialogueMessage,
                          dialogue_attachments: tmpFiles
                        }
                      )
                    } else {
                      props.onChangeDialogsHOC( 
                        'internalDialogueMessage',
                        {
                          ...props.internalDialogueMessage,
                          dialogue_attachments: tmpFiles
                        }
                      )
                    }
                    mainFilePondRef.current.removeFiles()
                    props.setIsUploadModalOpen( false )
                  }
                }
                reader.readAsDataURL( file.file )
              })
            } else {
              if (!props.isInternalDialogue){
                props.onChangeDialogsHOC( 
                  'dialogueMessage',
                  {
                    ...props.dialogueMessage,
                    dialogue_attachments: []
                  }
                )
              } else {
                props.onChangeDialogsHOC( 
                  'internalDialogueMessage',
                  {
                    ...props.internalDialogueMessage,
                    dialogue_attachments: []
                  }
                )
              }
              mainFilePondRef.current.removeFiles()
            }
          }}
          allowMultiple={ true }
        />
      </ModalBody>
    </Modal>
  )
}

export default UploadModal